import { getTourV2OfferCacheKey } from 'lib/tours/tourV2OfferCacheKey'

export function resolveTourV2OfferFromStore(
  tourOffers: App.State['offer']['tourV2Offers'],
  offerId: string | undefined,
  privateRequestKey?: string,
): App.Tours.TourV2Offer | undefined {
  if (!offerId || !tourOffers) {
    return undefined
  }

  const standardKey = getTourV2OfferCacheKey(offerId, privateRequestKey, false)
  const allPackagesKey = getTourV2OfferCacheKey(offerId, privateRequestKey, true)

  return tourOffers[standardKey] ?? tourOffers[allPackagesKey] ?? tourOffers[offerId]
}
